module.exports = __webpack_public_path__ + "static/img/info_title5.868770b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_title5.png
// module id = 5fGU
// module chunks = 4